import React from 'react';

const addonSubHeading = (props) => (
    <h4 className={`u-fontSize13 u-fontWeightRegular u-textColorLight ${props.active ? 'u-fontWeightMedium' : null} `}>{props.children}</h4>
);

export default addonSubHeading;


// WEBPACK FOOTER //
// ./src/components/Addons/AddonsTypography/AddonSubHeading/AddonSubHeading.js